import {AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {FiltroModel} from "@componentes/Filtros/Filtro.model";
import {FiltrosComponent} from "@componentes/Filtros/Filtros.component";
import {TipoFiltroEnum} from "@componentes/Filtros/Filtros.enum";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {PreparacionEvaluacionFormComponent} from "./preparacionevaluacionForm.component";


@Component({
    selector: 'preparacionevaluacion',
    templateUrl: './preparacionevaluacion.component.html',
    styleUrls: ['./preparacionevaluacion.component.scss']
})

export class PreparacionEvaluacionComponent implements AfterViewInit {
    entidad: PeriodoEvaluacion;
    dataTable: Array<any>
    SelCiclo: any[];
    SelNivel: any[];
    consulta!: boolean;

    @ViewChild("preparacionevaluacionPlantilla", {read: ViewContainerRef}) preparacionevaluacionPlantilla!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.uriApi = "planeacion/preparacionevaluacion/buscar";
        this.entidad = new PeriodoEvaluacion();
        this.SelCiclo = [];
        this.dataTable = [];
        this.SelNivel = [];
        this.GenerarFiltros();
    }

    ngAfterViewInit() {
        this.SetFiltros();
        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Ciclo',
                    DisplayValor: 'nombre',
                    ValorName: 'cicloid',
                    Opciones: this.SelCiclo,
                    Propiedad: "cicloid",
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Inicio Periodo',
                    Propiedad: "fechainicioperiodo",
                    Obligatorio: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Inicio Acuerdos',
                    Propiedad: "fechainicioacuerdos",
                    Obligatorio: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Fin Acuerdos',
                    Propiedad: "fechafinacuerdos",
                    Obligatorio: false,
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    SetFiltros() {
        this.appService.Get("catalogo/ciclo").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCiclo = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'cicloid');
                if (filtro) {
                    filtro.Opciones = this.SelCiclo;
                }
            }
        });
    }

    Formulario(accionid: number, entidad: any) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Plantilla";
                this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
                break;
            case 2:
                accion = "Puestos";
                this.appService.Get("planeacion/preparacionevaluacion/preparacion/plantilla/" + entidad.periodoevaluacionid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        if (res.data.length > 0) {
                            this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
                        } else {
                            this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen plantillas asignadas, por favor asigne una plantilla para continuar con las preguntas");
                        }
                    }
                })
                break;
        }

    }

    cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
        this.consulta = true;
        this.preparacionevaluacionPlantilla.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PreparacionEvaluacionFormComponent);
        var ref: ComponentRef<any> = this.preparacionevaluacionPlantilla.createComponent(factory);
        ref.instance.entidadperiodo = data.entidad;
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }
}